<div *ngIf="!useCondensedLayout" class="view-details-container">
  <!-- Case Id -->
  <div *ngIf="caseId" id="viewPage_caseId">
    <span data-testid="caseId-label">Case ID: </span><strong data-testid="caseId-value">{{caseId}}</strong>
  </div>

  <!-- Status -->
  <div id="viewPage_status" *ngIf="status">
    <span data-testid="status-label">Status: </span><strong data-testid="status-value">{{status}}</strong>
  </div>

  <!-- Submitted on -->
  <div id="viewPage_submittedOn" *ngIf="submittedOn">
    <span data-testid="submittedOn-label">Submitted on: </span><strong
      data-testid="submittedOn-value">{{submittedOn}}</strong>
  </div>

  <!-- Source -->
  <div id="viewPage_source" *ngIf="source">
    <span data-testid="source-label">Source: </span><strong data-testid="source-value">{{source}}</strong>
  </div>

  <!-- Initiated By -->
  <div id="viewPage_initiatedBy" *ngIf="initiatedBy">
    <span data-testid="initiatedBy-label">Initiated by: </span><strong
      data-testid="initiatedBy-value">{{initiatedBy}}</strong>
  </div>

  <!-- Released On -->
  <div id="viewPage_releasedOn" *ngIf="hasMmInitiateAccess && releasedDate">
    <span data-testid="releasedOn-label">Released on: </span><strong
      data-testid="releasedOn-value">{{releasedDate}}</strong>
  </div>

  <!-- Released By -->
  <div id="viewPage_releasedBy" *ngIf="hasMmInitiateAccess && releasedBy">
    <span data-testid="releasedBy-label">Released by: </span><strong
      data-testid="releasedBy-value">{{releasedBy}}</strong>
  </div>


  <!-- Last modified -->
  <div id="viewPage_lastModified" *ngIf="isLastModified">
    <span data-testid="lastModified-label">Last modified: </span><strong
      data-testid="lastModified-value">{{lastModified}}</strong>
  </div>

  <!-- Last modified by -->
  <div id="viewPage_lastModifiedBy" *ngIf="isLastModified">
    <span data-testid="lastModifiedBy-label">Last modified by: </span><strong
      data-testid="lastModifiedBy-value">{{lastModifiedBy}}</strong>
  </div>

  <!-- Last modification source -->
  <div id="viewPage_lastModificationSource" *ngIf="isLastModified">
    <span data-testid="lastModificationSource-label">Last modification source: </span><strong
      data-testid="lastModificationSource-value">{{lastModificationSource}}</strong>
  </div>
</div>

<div *ngIf="useCondensedLayout" class="view-details-container row">
  <div [ngClass]="{'column': condensedViewHasSecondColumn}">
    <!-- Case Id -->
    <div *ngIf="caseId" id="viewPage_caseId">
      <span data-testid="caseId-label" class="condensed-details-label">Case ID: </span>
      <span data-testid="caseId-value" class="condensed-details-data">{{caseId}}</span>
    </div>
    
    <!-- Status -->
    <div id="viewPage_status" *ngIf="status">
      <span data-testid="status-label" class="condensed-details-label">Status: </span>
      <span data-testid="status-value" class="condensed-details-data">{{status}}</span>
    </div>

    <!-- Submitted on -->
    <div id="viewPage_submittedOn" *ngIf="submittedOn">
      <span data-testid="submittedOn-label" class="condensed-details-label">Submitted on: </span>
      <span data-testid="submittedOn-value" class="condensed-details-data">{{submittedOn}}</span>
    </div>

    <!-- Source -->
    <div id="viewPage_source" *ngIf="source">
      <span data-testid="source-label" class="condensed-details-label">Source: </span>
      <span data-testid="source-value" class="condensed-details-data">{{source}}</span>
    </div>

    <!-- Initiated By -->
    <div id="viewPage_initiatedBy" *ngIf="initiatedBy">
      <span data-testid="initiatedBy-label" class="condensed-details-label">Initiated by: </span>
      <span data-testid="initiatedBy-value" class="condensed-details-data">{{initiatedBy}}</span>
    </div>
  </div>

  <div [ngClass]="{'column': condensedViewHasSecondColumn}">
    <!-- if any new fields are added here, be sure to add them to the condensedViewHasSecondColumn getter -->
    <!-- Released On -->
    <div id="viewPage_releasedOn" *ngIf="hasMmInitiateAccess && releasedDate">
      <span data-testid="releasedOn-label" class="condensed-details-label">Released on: </span>
      <span data-testid="releasedOn-value" class="condensed-details-data">{{releasedDate}}</span>
    </div>

    <!-- Released By -->
    <div id="viewPage_releasedBy" *ngIf="hasMmInitiateAccess && releasedBy">
      <span data-testid="releasedBy-label" class="condensed-details-label">Released by: </span>
      <span data-testid="releasedBy-value" class="condensed-details-data">{{releasedBy}}</span>
    </div>


    <!-- Last modified -->
    <div id="viewPage_lastModified" *ngIf="isLastModified">
      <span data-testid="lastModified-label" class="condensed-details-label">Last modified: </span>
      <span data-testid="lastModified-value" class="condensed-details-data">{{lastModified}}</span>
    </div>

    <!-- Last modified by -->
    <div id="viewPage_lastModifiedBy" *ngIf="isLastModified">
      <span data-testid="lastModifiedBy-label" class="condensed-details-label">Last modified by: </span>
      <span data-testid="lastModifiedBy-value" class="condensed-details-data">{{lastModifiedBy}}</span>
    </div>

    <!-- Last modification source -->
    <div id="viewPage_lastModificationSource" *ngIf="isLastModified">
      <span data-testid="lastModificationSource-label" class="condensed-details-label">Last modification source: </span>
      <span data-testid="lastModificationSource-value" class="condensed-details-data">{{lastModificationSource}}</span>
    </div>
  </div>
</div>
<sdps-divider variation="secondary"></sdps-divider>